import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Stack,
} from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MaterialTypography from "../../../../../../../components/MaterialTypography";

const Details = ({ data }) => {
  // console.log(data, 'data from the details');

  return (
    <Accordion
      sx={{
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          minHeight: "32px",
          marginBottom: 0,
          "&.MuiAccordionSummary-root": {
            paddingY: 0.5,
          },
          "& .MuiAccordionSummary-content": {
            marginY: "2px",
          },
        }}
      >
        <Stack>
          <MaterialTypography variant="h6" color="dark" fontWeight="bold">
            Details
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            View task details here..
          </MaterialTypography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          paddingTop: 0.5,
        }}
      >
        <Grid container spacing={1} sx={{ padding: 0 }}>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Project Code
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.project_code}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Task Code
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.task_code}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Task Created Name
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.task_creater_name}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Task Title
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.task_title}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Project Name
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.project_name}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Start Date
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.start_date}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                End Date
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.end_date}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Actual Start Date
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.actual_start_date || "Null"}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Actual End Date
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.actual_end_date}
              </MaterialTypography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Stack direction="row" spacing={5}>
              <MaterialTypography
                variant="body1"
                color="dark"
                fontWeight="bold"
                sx={{ fontSize: "14px" }}
              >
                Assignee
              </MaterialTypography>
              <MaterialTypography
                variant="body1"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                {data?.assignee_name}
              </MaterialTypography>
            </Stack>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default Details;
